module.exports = __webpack_public_path__ + "static/Another-Birthday_feature-7aca5f1c876b9068a07909254a6d2f6c.webp";